"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledTitle = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-flow: column wrap;
	align-items: center;

	h1 {
		font-size: ${({ theme }) => `${theme.titleFontSize}`};
		color: ${({ theme }) => `${theme.textBlack2}`};
		text-align: center;
		font-weight: ${({ theme }) => `${theme.fontNormal}`};
		margin: 20px 0 0 0;
		outline: none;
		letter-spacing: 0;

		@media only screen and (max-width: 41em) {
			margin: 20px 0px;
			font-size: ${({ theme }) => `${theme.bigFontSize}`};
		}

		@media (max-width: $xxs-size) {
		margin: 10px;
		}
	}

	h2 {
		color: ${({ theme }) => theme.gray2};
		font-size: ${({ theme }) => `${theme.baseFontSize}`};
		text-align: center;
		font-weight: ${({ theme }) => theme.fontLight};

		@media only screen and (max-width: 41em) {
			font-size: ${({ theme }) => `${theme.smallFontSize}`};
		}
	}
`;
exports.Title = react_1.default.forwardRef((props, ref) => {
    const { title, subtitle, dataTestid, id } = props;
    return (react_1.default.createElement(StyledTitle, null,
        react_1.default.createElement("h1", { id: id, tabIndex: -1, className: 'ie-text-wrap', ref: ref, "data-testid": dataTestid }, title),
        subtitle && react_1.default.createElement("h2", null, subtitle)));
});
